const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/ai/projects/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { ACTIVE_PROJECTS_TAB, ARCHIVED_PROJECTS_TAB } from "@/react/pages/CircleAi/Projects/constants";
interface ProjectsSearch {
  tab?: string;
}
const validateSearch = (search: Record<string, unknown>): ProjectsSearch => ({
  tab: search.tab === ARCHIVED_PROJECTS_TAB ? ARCHIVED_PROJECTS_TAB : ACTIVE_PROJECTS_TAB
});
export const Route = createFileRoute("/_protected/ai/projects/")({
  validateSearch,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});